<template>
  <div class="login-dark">
    <form method="post">
      <h2 class="sr-only">Login Form</h2>
      <div class="illustration">
        <i class="icon ion-ios-locked-outline"></i>
      </div>
      <div class="form-group">
        <input
          class="form-control"
          ref="userRef"
          type="text"
          name="name"
          placeholder="Гэрээний дугаар"
          v-model.trim="$v.username.$model"
          :class="{
            'is-invalid': $v.username.$error,
            'is-valid': !$v.username.$invalid,
          }"
          v-on:keyup.enter="nextPlease"
          autocomplete="on"
        />
        <div class="valid-feedback"></div>
        <div class="invalid-feedback">
          <span v-if="!$v.username.required">Гэрээний дугаар оруулна уу.</span>
        </div>
      </div>
      <div class="form-group" v-show="!resendPassword">
        <input
          class="form-control"
          id="passwordField"
          type="password"
          name="password"
          placeholder="Нууц үг"
          v-model.trim="$v.password.$model"
          :class="{
            'is-invalid': $v.password.$error,
            'is-valid': !$v.password.$invalid,
          }"
          autocomplete="off"
          @keyup.enter="login()"
        />
        <div class="valid-feedback"></div>
        <div class="invalid-feedback">
          <span v-if="!$v.password.required">Нууц үг оруулна уу.</span>
        </div>
      </div>
      <div class="form-group" v-show="resendPassword">
        <label>Бүртгэлтэй и-мэйл</label>
        <input
          class="form-control"
          id="email"
          type="email"
          v-model="maskedEmail"
          disabled
        />
      </div>
      <div class="form-group">
        <d-row>
          <d-col align="left" v-show="resendPassword">
            <span> <a @click="resendPassword = false">Буцах</a></span>
          </d-col>
          <d-col align="right" v-show="!resendPassword">
            <span> <a @click="clickResend()">Нууц үг сэргээх </a></span>
          </d-col>
        </d-row>
      </div>
      <div class="form-group">
        <button
          v-show="!resendPassword"
          class="btn btn-primary btn-block"
          type="button"
          @click="login()"
        >
          Нэвтрэх
        </button>
        <button
          v-show="resendPassword"
          class="btn btn-primary btn-block"
          type="button"
          @click="resend()"
        >
          Илгээх
        </button>
        <div class="demo-container p-p-0 p-p-sm-1 p-p-md-2 p-p-lg-3">
          <span v-if="status == 'wrongPassword'" class="wrongfields"
            >Нэр нууц үг буруу.</span
          >
          <span v-if="status == 'userNotFound'" class="wrongfields"
            >Бүртгэлгүй хэрэглэгч.</span
          >
        </div>
      </div>
    </form>
    <Toast position="bottom-center" />
  </div>
</template>

<script>
import axios from "axios";
import Toast from "primevue/toast";
import moment from "moment";
import { required } from "vuelidate/lib/validators";

const baseURL = "https://mongolsat.mn/isat/contract";

export default {
  name: "login",
  components: {
    Toast,
  },
  data() {
    return {
      disabled: 0,
      username: "",
      password: "",
      status: "",
      email: "",
      maskedEmail: "",
      resendPassword: false,
    };
  },
  validations: {
    username: {
      required,
    },
    password: {
      required,
    },
  },
  methods: {
    nextPlease() {
      document.getElementById("passwordField").focus();
    },
    async clickResend() {
      if (this.username == "") {
        this.$refs.userRef.focus();
        this.$toast.add({
          severity: "error",
          summary: "Гэрээний дугаар оруулна уу",
          detail: "",
          life: 3000,
        });
      } else {
        this.resendPassword = true;
        var config = {
          method: "get",
          url:
            "https://mongolsat.mn/isat/contract/get/email?contractId=" +
            this.username +
            "",
          headers: {
            "Content-Type": "application/json",
          },
        };

        await axios(config)
          .then((response) => {
            if (response != null) {
              if (response.data != "") {
                this.email = response.data;
                var sliced = this.email.slice(0, 5);
                this.maskedEmail = this.email.replace(sliced, "*****");
              }
            }
          })
          .catch((error) => console.log(error.response));
      }
    },
    async resend() {
      if (this.username != "" && this.email != "") {
        var data = JSON.stringify({
          ContractId: this.username,
          Email: this.email,
        });

        var config = {
          method: "post",
          url: "https://mongolsat.mn/isat/contract/password/send",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };

        await axios(config)
          .then((response) => {
            if (response != null) {
              this.$toast.add({
                severity: "success",
                summary:
                  "Таны " +
                  this.username +
                  " дугаартай гэрээний шинэ нууц үг амжилттай сэргээгдэж бүртгэлтэй имэйл " +
                  this.maskedEmail +
                  " илгээгдлээ",
                detail: "",
                life: 6000,
              });
            }
          })
          .catch((error) => console.log(error.response));
      } else if (this.username == "") {
        this.$refs.userRef.focus();
        this.$toast.add({
          severity: "error",
          summary: "Гэрээний дугаар оруулна уу",
          detail: "",
          life: 3000,
        });
      } else if (this.email == "")
        this.$toast.add({
          severity: "error",
          summary:
            this.username +
            " гэрээний дугаар дээр и-мэйл хаяг бүртгэлгүй байна, Та системийн админтай холбоо барина уу! ",
          detail: "976-7100-0000",
          life: 8000,
        });
    },
    async login() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toast.add({
          severity: "error",
          summary: "Шаардлагатай талбаруудыг бөглөнө үү",
          detail: "",
          life: 3000,
        });
      } else {
        await axios
          .post(baseURL + "/token", {
            username: this.username,
            password: this.password,
            duration: 72200,
          })
          .then(
            (response) => {
              if (response.data.code == 0) {
                var uToken = response.data.object;

                var configData = {
                  method: "post",
                  url: "https://mongolsat.mn/isat/contract/data",
                  headers: {
                    Authorization: "Bearer " + uToken,
                  },
                };

                var configPhone = {
                  method: "post",
                  url: "https://www.mongolsat.mn/isat/contract/phones",
                  headers: {
                    Authorization: "Bearer " + uToken,
                  },
                };

                var configDetail = {
                  method: "post",
                  url: "https://www.mongolsat.mn/isat/contract/detail",
                  headers: {
                    Authorization: "Bearer " + uToken,
                  },
                };

                var configOption = {
                  method: "get",
                  url: "https://www.mongolsat.mn/isat/product/additional",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + uToken,
                  },
                };

                var configPayment = {
                  method: "get",
                  url: "https://mongolsat.mn/isat/contract/payments?page=1",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + uToken,
                  },
                };

                var configInvoice = {
                  method: "get",
                  url: "https://mongolsat.mn/isat/contract/invoices?page=1&rows=10",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + uToken,
                  },
                };

                const requestOne = axios(configData);
                const requestTwo = axios(configPhone);
                const requestThirth = axios(configDetail);
                const requestFourth = axios(configOption);
                const requestFifth = axios(configPayment);
                const requestSixth = axios(configInvoice);

                axios
                  .all([
                    requestOne,
                    requestTwo,
                    requestThirth,
                    requestFourth,
                    requestFifth,
                    requestSixth,
                  ])
                  .then(
                    axios.spread((...responses) => {
                      const responseOne = responses[0];
                      const responseTwo = responses[1];
                      const responseThirth = responses[2];
                      const responseFourth = responses[3];
                      const responseFifth = responses[4];
                      const responseSixth = responses[5];

                      if (
                        responseOne.data.code == 0 &&
                        responseOne.data.object != null
                      ) {
                        this.$store.dispatch("retrieveAddData", {
                          addData:
                            responseOne.data.object.topupQuota == null
                              ? 0
                              : responseOne.data.object.topupQuota,
                        });
                        this.$store.dispatch("retrieveRemainData", {
                          remainData:
                            responseOne.data.object.remainingQuota == null
                              ? 0
                              : responseOne.data.object.remainingQuota,
                        });
                         this.$store.dispatch("retrieveUsedData", {
                          usedData:
                            responseOne.data.object.accountableTraffic == null
                              ? 0
                              : responseOne.data.object.accountableTraffic,
                        });
                      }

                      if (
                        responseTwo.data.code == 0 &&
                        responseTwo.data.object.length > 0
                      ) {
                        var tmpPhoneList = [];
                        var i = 0;

                        for (i = 0; i < responseTwo.data.object.length; i++) {
                          var data = {};
                          data.id = i;
                          data.name =
                            responseTwo.data.object[i].name == null
                              ? ""
                              : responseTwo.data.object[i].name;
                          data.phone =
                            responseTwo.data.object[i].phone == null
                              ? ""
                              : responseTwo.data.object[i].phone;
                          data.balance =
                            (responseTwo.data.object[i].balance == null ||
                              responseTwo.data.object[i].balance) < 1
                              ? 0
                              : responseTwo.data.object[i].balance;
                          tmpPhoneList.push(data);
                        }
                        this.$store.dispatch("retrievePhoneData", {
                          phoneData: tmpPhoneList,
                        });
                        this.$store.dispatch("retrieveSelected", {
                          selected: tmpPhoneList[0],
                        });
                        this.$store.dispatch("retrieveBalance", {
                          balance:
                            responseTwo.data.object[0].balance < 1
                              ? 0
                              : responseTwo.data.object[0].balance,
                        });

                        var dataCurrent = JSON.stringify({
                          phone: tmpPhoneList[0].phone,
                          beginTime: new Date(
                            new Date().getFullYear() +
                              "/" +
                              new Date().getMonth() +
                              "/" +
                              new Date().getDate()
                          ),
                          endTime: new Date(),
                        });

                        var configDataCurrent = {
                          method: "post",
                          url: "https://www.mongolsat.mn/isat/contract/phone/callers",
                          headers: {
                            Authorization: "Bearer " + uToken,
                            "Content-Type": "application/json",
                          },
                          data: dataCurrent,
                        };

                        const requestOne = axios(configDataCurrent);

                        axios
                          .all([requestOne])
                          .then(
                            axios.spread((...responses) => {
                              const responseOne = responses[0];

                              var i = 0;
                              var currentFeeData = [];
                              var currentDataTable = [];

                              if (
                                responseOne.data.code == 0 &&
                                responseOne.data.object.infoCdrs != null
                              ) {
                                for (
                                  i = 0;
                                  i < responseOne.data.object.infoCdrs.length;
                                  i++
                                ) {
                                  currentFeeData.push(
                                    responseOne.data.object.infoCdrs[i].fee
                                  );

                                  var data = {};
                                  data.Id = 1 + i;
                                  data.incomingNumber =
                                    responseOne.data.object.infoCdrs[
                                      i
                                    ].callerE164;
                                  data.outcomingNumber =
                                    responseOne.data.object.infoCdrs[
                                      i
                                    ].calleeE164;
                                  data.amount =
                                    responseOne.data.object.infoCdrs[i].fee;
                                  data.duration =
                                    responseOne.data.object.infoCdrs[i].feeTime;
                                  data.startTime = moment(
                                    new Date(
                                      responseOne.data.object.infoCdrs[i].start
                                    )
                                  ).format("MM/DD/YYYY hh:mm");
                                  data.stopTime = moment(
                                    new Date(
                                      responseOne.data.object.infoCdrs[i].stop
                                    )
                                  ).format("MM/DD/YYYY hh:mm");
                                  currentDataTable.push(data);
                                }
                                this.$store.dispatch("retrieveUserFee", {
                                  userFee: currentFeeData,
                                });

                                this.$store.dispatch("retrieveUserTable", {
                                  userTable: currentDataTable,
                                });
                              }
                            })
                          )
                          .catch((errors) => {
                            //errors.
                            console.log(errors);
                          });
                      }
                      if (
                        responseThirth.data.code == 0 &&
                        responseThirth.data.object != null
                      ) {
                        this.$store.dispatch("retrieveUserDetail", {
                          userDetail: {
                            id: responseThirth.data.object[0].Id,
                            firstName: responseThirth.data.object[0].FirstName,
                            lastName: responseThirth.data.object[0].LastName,
                            customerId:
                              responseThirth.data.object[0].CustomerId,
                            register: responseThirth.data.object[0].Register,
                            district: responseThirth.data.object[0].District,
                            apartment: responseThirth.data.object[0].Apartment,
                            khoroo: responseThirth.data.object[0].Khoroo,
                            door: responseThirth.data.object[0].Door,
                            workPlace: responseThirth.data.object[0].WorkPlace,
                            position: responseThirth.data.object[0].Position,
                            phoneNumber:
                              responseThirth.data.object[0].PhoneNumber,
                            phoneNumber2:
                              responseThirth.data.object[0].PhoneNumber2,
                            email: responseThirth.data.object[0].Email,
                            relateWho: responseThirth.data.object[0].RelateWho,
                            relateName:
                              responseThirth.data.object[0].RelateName,
                            relateRegion:
                              responseThirth.data.object[0].RelateRegion,
                            relatePhoneNumber:
                              responseThirth.data.object[0].RelatePhoneNumber,
                            relateEmail:
                              responseThirth.data.object[0].RelateEmail,
                            productName:
                              responseThirth.data.object[0].ProductName,
                          },
                        });
                      }
                      if (
                        responseFourth.data != null &&
                        responseFourth.data.length > 0
                      ) {
                        this.$store.dispatch("retrieveOptions", {
                          options: responseFourth.data,
                        });
                      }
                      if (
                        responseFifth.data != null &&
                        responseFifth.data.length > 0
                      ) {
                        this.$store.dispatch("retrievePayments", {
                          payments: responseFifth.data,
                        });
                      }
                      if (
                        responseSixth.data.records != null &&
                        responseSixth.data.records.length > 0
                      ) {
                        this.$store.dispatch("retrieveInvoice", {
                          invoice: responseSixth.data.records,
                        });
                      }
                    })
                  )
                  .catch((errors) => {
                    //errors.
                    console.log(errors);
                  });

                //store data
                this.$store.dispatch("retrieveToken", {
                  userToken: uToken,
                });
                this.$router.push("userDashboard");
              } else {
                this.$toast.add({
                  severity: "error",
                  summary:
                    "Нэвтрэх амжилтгүй нэр эсвэл нууц үг буруу дахин оролдоно уу !",
                  detail: "",
                  life: 3000,
                });
              }
            },
            (error) => {
              console.log(error);
            }
          );
      }
    },
  },
};
</script>

<style scoped>
.wrongfields {
  color: rgb(165, 35, 59);
}

.login-dark {
  height: 900px;
  background: #475d62 url(../assets/img/statellite.jpg);
  background-size: cover;
  position: relative;
}

.login-dark form {
  max-width: 320px;
  width: 90%;
  background-color: #1e2833;
  padding: 40px;
  border-radius: 4px;
  transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
  left: 50%;
  color: #fff;
  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.2);
}

.login-dark .illustration {
  text-align: center;
  padding: 15px 0 20px;
  font-size: 100px;
  color: rgb(165, 35, 59);
}

.login-dark form .form-control {
  background: none;
  border: none;
  border-bottom: 1px solid #434a52;
  border-radius: 0;
  box-shadow: none;
  outline: none;
  color: inherit;
}

.login-dark form .btn-primary {
  background: rgb(165, 35, 59);
  border: none;
  border-radius: 4px;
  padding: 11px;
  box-shadow: none;
  margin-top: 26px;
  text-shadow: none;
  outline: none;
}

.login-dark form .btn-primary:hover,
.login-dark form .btn-primary:active {
  background: #214a80;
  outline: none;
}

.login-dark form .forgot {
  display: block;
  text-align: center;
  font-size: 12px;
  color: #6f7a85;
  opacity: 0.9;
  text-decoration: none;
}

.login-dark form .forgot:hover,
.login-dark form .forgot:active {
  opacity: 1;
  text-decoration: none;
}

.login-dark form .btn-primary:active {
  transform: translateY(1px);
}
</style>
